import * as styles from './styles.css';
import Text from '../common/text';
import { useAtom } from 'jotai/react';
import { Button } from '@mui/material';
import { InputBox } from './input-box';
import { IComponent, IEducation } from '../../interfaces';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useProps } from '../../hooks/use-props';
import { atomWithStorage } from 'jotai/vanilla/utils';
import LOCAL_STORAGE_DATA from '../../constants/local-storage-data';
export interface IEducationProps {
  id: string;
}

interface IEducationAtom extends IComponent {
  value: IEducation[];
}

const blank_state = {
  school: '',
  degree: '',
  major: '',
  graduation_year: '',
  gpa: '',
};

const primitives = {
  education: atomWithStorage<IEducation[]>(LOCAL_STORAGE_DATA.EDUCATION, [blank_state]),
};

const useEducation = (id: string) => {
  const [local_state, setLocalState] = useAtom(primitives.education);
  const { props, addAnswer } = useProps<IEducationAtom>({ id, initial_state: local_state });
  const checkRequired = (education) => {
    const boxes_with_answers = education.filter((box) => {
      const keys = Object.keys(box);
      return keys.every((key) => {
        return box[key] !== '';
      });
    });
    if (boxes_with_answers.length === 0) return addAnswer({ education: undefined });
    return addAnswer({ education: boxes_with_answers });
  };
  return {
    props: {
      ...props,
      value: local_state,
    },
    addBox: () => setLocalState((prev) => [...prev, blank_state]),
    removeBox: (index: number) => {
      const education = [...local_state];
      education.splice(index, 1);
      setLocalState(education);
      checkRequired(education);
    },
    addAnswer: (new_state: IEducation, index: number) => {
      const education = [...local_state];
      education[index] = { ...education[index], ...new_state };
      setLocalState(education);
      checkRequired(education);
    },
  };
};

const Education = ({ id }: IEducationProps) => {
  const {
    props: { value, show },
    addBox,
    removeBox,
    addAnswer,
  } = useEducation(id);

  if (!show) return null;
  return (
    <div id={id} className={styles.root}>
      <Text id={`${id}-text`} title={'Education'}>
        Tutors are required to be enrolled in or have graduated from a four-year collegiate program.
      </Text>
      <div className={styles.inputBoxes}>
        {value.map((state, index) => (
          <InputBox
            key={`${id}-${index}`}
            id={`${id}-${index}`}
            isFirst={index === 0}
            value={state}
            setValue={(new_state) => addAnswer(new_state, index)}
            onRemove={() => removeBox(index)}
          />
        ))}
      </div>
      <Button
        id={`${id}-add_new`}
        variant={'text'}
        className={styles.add_new}
        startIcon={<AddCircleOutlineIcon />}
        onClick={addBox}
      >
        Add School
      </Button>
    </div>
  );
};

export default Education;
